// extracted by mini-css-extract-plugin
export default {"appContainer":"HArnjLuuoDdqdy2WTNEL","mainContent":"o_BuaxzaOpfUV15IwLQj"};